import styled from 'styled-components'
import { theme } from '@/client/components'
const { breakpoint, borders, color, font, space } = theme

export const Hero = styled.div`
  position: relative;
  margin-bottom: ${space.xl3};
`

export const ImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
`

export const InnerHero = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  padding-top: ${space.lg};

  & > div {
    height: calc(100% - ${space.xl6});
  }
`

export const Badge = styled.span`
  display: inline-block;
  padding: ${space.xs} ${space.md};
  margin-bottom: ${space.sm};
  border-radius: ${borders.radius.pill};
  background-color: ${color.primary.pure};
  color: ${color.grayscale.white};
  font-size: ${font.size.xsmall};
  text-align: center;
  vertical-align: middle;
  white-space: nowrap;

  @media (min-width: ${breakpoint.lg}) {
    margin-bottom: ${space.lg};
  }
`

export const Title = styled.h1`
  margin: 0 0 ${space.md};
  color: ${color.grayscale.white};
  font-family: ${font.family.heading};
  text-align: center;
  font-weight: ${font.weight.bold};
  font-size: ${font.size.h5};
  line-height: ${font.lineHeight.xs};

  @media (min-width: ${breakpoint.lg}) {
    font-size: ${font.size.h3};
    margin: 0 0 ${space.md};
  }

  @media (min-width: ${breakpoint.xl}) {
    margin: 0 0 ${space.xl2};
    font-size: ${font.size.h2};
  }
`

export const Subtitle = styled.h2`
  margin: 0 0 ${space.lg};
  color: ${color.grayscale.white};
  font-family: ${font.family.text};
  text-align: center;
  font-weight: ${font.weight.normal};
  font-size: ${font.size.small};
  line-height: ${font.lineHeight.md};

  @media (min-width: ${breakpoint.xl}) {
    font-size: ${font.size.h6};
    margin: 0 0 ${space.xl3};
  }
`

export const MainHero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
  height: 100%;

  @media (min-width: ${breakpoint.lg}) {
    width: 48rem;
  }
`
